export default {
  studentDetail: {
    title: 'Item {{itemIndex}}',
    partQuestionDetail: {
      partTitle: 'Part {{partLetter}}',
      answerDoesNotApply: 'Answer does not apply',
      unscoredBadge: 'Unscored'
    }
  },
  itemScore: {
    title: 'Item Score'
  }
};